import React  from "react";
import { formatMoney } from '../../../../../Utils/formatMoney';

import { FiX } from "react-icons/fi";
import { FaMotorcycle, FaMoneyBillAlt} from 'react-icons/fa';
import { BsCreditCard } from 'react-icons/bs';
import { GiShoppingBag } from 'react-icons/gi';
import { MdAttachMoney } from 'react-icons/md';
import { RiBankLine } from 'react-icons/ri';
import { SiAirtable } from 'react-icons/si';
import {Container,Content,Menu,Header,ContainerStatus,TypeOfShopping,ProductsList,PaymentContainer,PaymentMethodContainer,AddressContainer,Divisor} from './styles';


import moment from 'moment';

export default function ModalOrders(props){
    
    const {onClose, status ,id, date, dsEmpresa,typeShoppingDescription,typeShopping, paymentMethod, feeDelivery, subtotal, total, products, address} = props;


    return(
        <Container onClick={onClose}>
            <Content>
                <Menu>
                    <div>
                        <button onClick={onClose}>
                            <FiX/>
                        </button>
                    </div>
                </Menu>

                <Header>
                    <h3>{dsEmpresa}</h3>
                    <p>Nº {id}</p>
                    <p>{moment(new Date(date)).locale('pt-BR').format('HH:mm')}h - {moment(new Date(date)).format('DD/MM/YYYY')}</p>
                </Header>

                <ContainerStatus>
                    {
                        status.toUpperCase() === 'R' ?
                        <p>Pedido Rejeitado</p>
                        :
                        status.toUpperCase() === 'A' ?
                        <p>Pedido Aberto</p>
                        :
                        <p>Pedido Confirmado</p>
                    }
                </ContainerStatus>

                <TypeOfShopping>
                    {
                        typeShopping === "DELIVERY" ?
                            <FaMotorcycle />
                        :
                        typeShopping  === "TAKEAWAY" ?
                            <GiShoppingBag />
                        : 
                        typeShopping === "TABLE" ?
                            <SiAirtable />
                        : <></>
                    }

                    <p>{typeShoppingDescription}</p>
                </TypeOfShopping>

                {
                    products.length > 0 ?
                    <>
                        <Divisor/>
                            {
                                products.map((product) => {
                                    return(
                                       <ProductsList>
                                           <li>
                                               <div className="item">
                                                    <div>
                                                            <span className="circle">{product.quantity}</span> 
                                                            <span>{product.name}</span>
                                                        </div> 
                                                    <span>{formatMoney(product.price)}</span>
                                               </div>

                                               <ul className="sublist">
                                                   {product.additionals.length > 0 && (
                                                       product.additionals.map((additional) => {
                                                           return <li>{additional.quantity}x {additional.name}</li>
                                                       })
                                                   )}
                                               </ul>
                                            </li>

                                       </ProductsList>
                                    )
                                })
                            }
                        <Divisor/>
                    </>
                    :
                    null
                }

                <PaymentContainer>
                    <p><span>Subtotal:</span> <span>{formatMoney(subtotal)}</span></p>
                    <p><span>Taxa de entrega:</span> <span>{formatMoney(feeDelivery)}</span></p>
                    <p><strong>Total:</strong> <strong>{formatMoney(total)}</strong></p>
                </PaymentContainer>
                
                <Divisor/>
                {
                    paymentMethod.type !== undefined ? 
                            <PaymentMethodContainer>
                                {
                                    paymentMethod.type === 3 || paymentMethod.type === 2 ?
                                        <BsCreditCard />
                                    :
                                    paymentMethod.type === 0 ?
                                        <FaMoneyBillAlt />
                                    :
                                    paymentMethod.type === 9 ?
                                        <RiBankLine />
                                    :
                                    <MdAttachMoney />
                                }

                                <p>{paymentMethod.description}</p>
                            </PaymentMethodContainer>
                    : <></>
                }
                <Divisor/>

                <AddressContainer>
                    <h4>Endereço de entrega</h4>
                    <p>{address.street},  {address.neighborhood} - {address.number}</p>
                    <p>{address.city} - {address.state}</p>
                </AddressContainer>
        
            </Content>
        </Container>
    )
}